import { toLocalDayKey } from "./dates.js";
import type { HistoryDaySection, TimeEntry } from "./models.js";

export function buildHistoryDaySections(entries: TimeEntry[]): HistoryDaySection[] {
  const grouped = new Map<string, TimeEntry[]>();

  for (const entry of entries) {
    const dayKey = toLocalDayKey(entry.startTime);
    const existing = grouped.get(dayKey);
    if (existing) {
      existing.push(entry);
    } else {
      grouped.set(dayKey, [entry]);
    }
  }

  return [...grouped.entries()]
    .sort(([left], [right]) => (left < right ? 1 : -1))
    .map(([date, dayEntries]) => {
      const sortedEntries = [...dayEntries].sort((left, right) =>
        left.startTime < right.startTime ? 1 : -1,
      );

      return {
        date,
        entries: sortedEntries,
        totalCountedDurationSeconds: sortedEntries.reduce(
          (total, entry) => total + entry.countedDurationSeconds,
          0,
        ),
      };
    });
}
